import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";
import sanitizeHtml from "../lib/sanitizeHtml";
import ChatboxWidget from "./ChatboxWidget";

export default function BlockRenderer({ position }) {
  const [blocks, setBlocks] = useState([]);
  const location = useLocation();

  useEffect(() => {
    // determine current page
    let page = "all";
    if (location.pathname === "/") page = "home";
    else if (location.pathname.startsWith("/forums")) page = "forums";
    else if (location.pathname.startsWith("/topic")) page = "topic";
    else if (location.pathname.startsWith("/u/")) page = "profile";

    api.get(`/idg/blocks/public?position=${position}&page=${page}`)
      .then(res => {
        const fetchedBlocks = res.data || [];
        setBlocks(fetchedBlocks);
      })
      .catch(err => console.error("Failed to load blocks", err));
  }, [position, location.pathname]);

  if (!blocks.length) return null;

  return (
    <div className={`idg-blocks idg-blocks-${position} flex flex-col gap-4 my-4 w-full`}>
      {blocks.map(b => (
        <div key={b.id} className="idg-block">
          {b.type === "html" ? (
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(b.content) }} />
          ) : b.widget_type === "chatbox" ? (
            <ChatboxWidget />
          ) : (
            <div className="tf-surface tf-clip-card p-4">
              <h4 className="text-orange-500 font-['Rajdhani'] mb-2">{b.name}</h4>
              <p className="text-zinc-400 text-sm">Widget {b.widget_type} (Not implemented yet)</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
